<template>
    <section
        class="cities"
        @click="handlerClick"
    >
        {{ userCity.cityPrintName }}
        <svg class="cities__icon"><use xlink:href="#svg-select"></use></svg>
    </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'Cities',
    computed: {
        ...mapState({
            userCity: ({ cities }) => cities.data?.userCity,
        })
    },
    methods: {
        handlerClick() {
            this.$DefModal.show({
                name: 'GuessCity',
                width: '340px',
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.cities{
    display: flex;
    align-items: center;
    align-self: stretch;
    margin-right: 12px;
    font-weight: 500;
    font-size: rem(14);
    line-height: 100%;
    cursor: pointer;
    @include point-lg{
        padding: 0 12px;
    }
    &__icon{
        display: block;
        width: 8px;
        height: 8px;
        fill: var(--background-black);
        margin-left: 4px;
        transform: translateY(-1px);
    }
}
</style>